import React, { useState } from 'react';

import { ScommesseTableShowMore } from 'components/scommesseTable/scommesseTableShowMore';
import { ScommesseTableStatsTrigger } from 'components/scommesseTable/scommesseTableStats/scommesseTableStatsTrigger';
import { SportMarcatoriTableRowMarcatore } from './sportMarcatoriTableRowMarcatore';
import { SportMarcatoriTableStats } from '../sportMarcatoriTableStats/SportMarcatoriTableStats';
import classNames from 'classnames';
import styles from './SportMarcatoriTableRow.module.scss';
import useWindowSize from 'hooks/useWindowSize';

export type SportMarcatoriTableRowProps = {
  children: React.ReactNode;
  hasBorderTop?: boolean;
  playerKey: string;
};

export const SportMarcatoriTableRow = ({ playerKey: player, children, hasBorderTop }: SportMarcatoriTableRowProps) => {
  const { isMobile } = useWindowSize();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className={classNames(styles.container, { [styles.borderTop]: hasBorderTop })} data-key={player}>
      <SportMarcatoriTableRowMarcatore containerClassname={styles.marcatore} playerKey={player} />
      <ScommesseTableStatsTrigger setIsOpen={setIsOpen} className={styles.stats} />
      <SportMarcatoriTableStats isOpen={isOpen} setIsOpen={setIsOpen} playerKey={player} />
      <div className={classNames(styles.quoteGroup, { [styles.cartOpen]: isOpen })}>{children}</div>

      {!isMobile && <ScommesseTableShowMore className={styles.showMore} />}
    </div>
  );
};
